export default __webpack_public_path__ + "static/rolling_door_b.e2690ef43531ab7ec1f5cd2634111df2.svg";